<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div style="padding: 0px 50px">
      <b-row v-if="!isMobile()">
        <b-col lg="8" sm="12" align-self="stretch">
          <b-carousel
            controls
            :interval="7000"
            v-model="slide"
            style="width: 100%; height: 100%"
          >
            <b-carousel-slide v-for="(announcement, index) in announcements" :key="index">
              <template #img>
                <vx-card
                  title-color="#fff"
                  content-color="#fff"
                  style="height: 100%"
                  :card-background="gradientColors[index]"
                >
                  <b-row style="height: 100%">
                    <b-col align-self="center">
                      <hr />
                      <div style="padding: 0px 70px">
                        <p class="mb-3">
                          <strong style="font-size: 25px"
                            >{{ announcement.Header }}
                          </strong>
                          <br />
                          <strong>{{ announcement.Description }}</strong>
                        </p>
                      </div>
                      <hr />
                    </b-col>
                  </b-row>
                </vx-card>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </b-col>
        <b-col
          lg="4"
          sm="12"
          align-self="stretch"
          :style="isMobile == true ? 'margin-bottom:15px; ' : ''"
        >
          <vs-card style="margin: 0px">
            <div style="text-align: center">
              <img
                src="@/assets/images/logo/gfuzum.png"
                alt="login"
                style="max-width: 60%; height: auto; display: inline-table"
              />
            </div>
            <div class="vx-card__title mb-3">
              <div style="text-align: center">
                <vs-divider> Giriş </vs-divider>

                Lütfen kullanıcı adı ve şifrenizi giriniz.
              </div>

              <div style="display: flex; flex-direction: column; text-align: start">
                <vs-input
                  name="bayiKodu"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  style="margin-bottom: 5px"
                  label-placeholder="Bayi Kodu"
                  v-model="bayikodu"
                  class="w-full"
                />
                <vs-input
                  name="email"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  style="margin-bottom: 5px"
                  label-placeholder="Kullanıcı Adı"
                  v-model="email"
                  class="w-full"
                />
                <vs-input
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Şifre"
                  v-model="password"
                  class="w-full mt-4"
                  @keyup.enter="onSubmit()"
                />
                <br />

                <vs-button type=""></vs-button>
                <vs-button class="float-right" style="margin-top: -25px" @click="onSubmit"
                  >Giriş</vs-button
                >
              </div>
            </div>
          </vs-card>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col sm="12" align-self="stretch" style="margin-bottom: 15px; margin-top: 15px">
          <vs-card style="margin: 0px">
            <div style="text-align: center">
              <img
                src="@/assets/images/logo/gfuzum.png"
                alt="login"
                style="max-width: 60%; height: auto; display: inline-table"
              />
            </div>
            <div class="vx-card__title mb-3">
              <div style="text-align: center">
                <vs-divider> Giriş </vs-divider>

                Lütfen kullanıcı adı ve şifrenizi giriniz.
              </div>

              <div style="display: flex; flex-direction: column; text-align: start">
                <vs-input
                  name="bayiKodu"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  style="margin-bottom: 5px"
                  label-placeholder="Bayi Kodu"
                  v-model="bayikodu"
                  class="w-full"
                />
                <vs-input
                  name="email"
                  icon-no-border
                  icon="icon icon-user"
                  icon-pack="feather"
                  style="margin-bottom: 5px"
                  label-placeholder="Kullanıcı Adı"
                  v-model="email"
                  class="w-full"
                />
                <vs-input
                  type="password"
                  name="password"
                  icon-no-border
                  icon="icon icon-lock"
                  icon-pack="feather"
                  label-placeholder="Şifre"
                  v-model="password"
                  class="w-full mt-4"
                  @keyup.enter="onSubmit()"
                />
                <br />

                <vs-button type=""></vs-button>
                <vs-button class="float-right" style="margin-top: -25px" @click="onSubmit"
                  >Giriş</vs-button
                >
              </div>
            </div>
          </vs-card>
        </b-col>
        <b-col
          sm="12"
          align-self="stretch"
          :style="isMobile == true ? 'margin-bottom:15px; margin-top:15px' : ''"
        >
          <b-carousel controls :interval="7000" v-model="slide">
            <b-carousel-slide v-for="(announcement, index) in announcements" :key="index">
              <template #img>
                <vx-card
                  title-color="#fff"
                  content-color="#fff"
                  :card-background="gradientColors[index]"
                >
                  <b-row>
                    <b-col align-self="center">
                      <hr />
                      <div>
                        <p class="mb-3">
                          <strong style="font-size: 25px"
                            >{{ announcement.Header }}
                          </strong>
                          <br />
                          <strong>{{ announcement.Description }}</strong>
                        </p>
                      </div>
                      <hr />
                    </b-col>
                  </b-row>
                </vx-card>
              </template>
            </b-carousel-slide>
          </b-carousel>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { isMobile } from "mobile-device-detect";

export default {
  data() {
    return {
      gradientColors: [
        "linear-gradient(120deg ,rgba(247,97,161,1), rgba(140,27,171,1))",
        "linear-gradient(120deg ,rgba(109,213,237,1), rgba(33,147,176,1)) ",
        "radial-gradient(circle, rgba(238,174,202,1) 0%, rgba(148,187,233,1) 100%)",
        "linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)",
        "linear-gradient(0deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%)",
        "linear-gradient(90deg, rgba(234,84,85,1) 0%, rgba(40,199,111,1) 100%)",
      ],
      slide: 0,
      email: "",
      password: "",
      bayikodu: "",
      checkbox_remember_me: false,
      sliding: null,
      announcements: [],
      PictureUrl: "",
    };
  },
  created() {
    this.fetchAnnouncements();
  },
  methods: {
    isMobile: function () {
      return isMobile;
    },
    errorImage(e) {
      if (e.type == "error") e.target.src = "http://sistem.uzum.com.tr/img/bg7.png";
    },
    // Tam URL oluşturmak için bir metod
    getFullImageUrl(partialUrl) {
      const baseUrl = "http://185.123.103.29";
      return baseUrl + partialUrl;
    },
    async fetchAnnouncements() {
      try {
        const response = await axios.get(
          "http://185.123.103.29/uzumCrm/api/Crm/genel-duyuru"
        );
        const responseData = response.data;

        // Veriyi ayrıştırıp announcements dizisine ekleyin.
        this.announcements = JSON.parse(responseData.json);
      } catch (error) {
        console.error("Duyuruları alma hatası", error);
      }
    },
    onSubmit() {
      this.$vs.loading();
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        vs: this.$vs,
        userDetails: {
          email: this.email,
          password: this.password,
          bayikodu: this.bayikodu,
        },
      };

      this.$store
        .dispatch("login", payload)
        .then(() => {
          this.$vs.loading.close();
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.vs-card--content {
  margin-bottom: 0px;
}

.vx-card .vx-card__collapsible-content .card-overlay {
  position: absolute;
  top: 120px;
  bottom: auto;
}

#page-login {
  #carousel-1 {
    width: 10px;
    /* Slider'ın genişlik değerini istediğiniz gibi ayarlayın */
    height: 10px;
    /* Slider'ın yükseklik değerini istediğiniz gibi ayarlayın */
    position: relative;
  }

  b-carousel-slide h1 {
    font-size: 16px;
    /* Yazı tipi boyutunu istediğiniz gibi ayarlayın */

    /* Yazı rengini istediğiniz gibi ayarlayın */
  }

  b-carousel-slide img {
    max-width: 10px;
    /* Max genişlik değerini istediğiniz gibi ayarlayın */
    height: 10px;
    /* Otomatik yükseklik hesaplanmasını sağlar */
  }
}

[dir="ltr"] .carousel-caption {
  right: 5% !important;
  left: 5% !important;
  color: black;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  height: 100%;
}

.carousel-inner {
  height: 100% !important;
}

.carousel {
  height: 100%;
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  height: 100%;
}

.vx-card .vx-card__collapsible-content.vs-con-loading__container {
  height: 100%;
}

[dir] .vx-card .vx-card__collapsible-content .vx-card__body {
  height: 100%;
}
</style>
